import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

// This is a best guess from the API response
// all the "null" fields are definitely wrong
export interface SignupResponse {
  credit: number;
  day_of_week: number;
  did_checkout: boolean;
  email: string;
  first_name: string;
  id: number;
  is_on_hold: null;
  is_on_hold_next_week: null;
  is_vip: boolean;
  last_name: string;
  life_promo: null;
  next_delivery_after_hold: null;
  on_hold_until_date: null;
  plan: null;
  rollover_credit_expiration: null;
  rollover_credits: number;
}

export interface SignupParams {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  captcha_token?: string;
}

export async function signup(params: SignupParams) {
  const { firstName, lastName, email, password, captcha_token } = params;
  return await send<SignupResponse>({
    path: '/api/signup/',
    method: 'POST',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }),
    body: {
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      captcha_token,
    },
  });
}
